import __request__ from "routing/request";
export function changeFieldType(request) {
  return __request__("PUT", "/system/indices/mappings", request, {}, {
    "Accept": ["application/json"]
  });
}
export function removeCustomMapping(request) {
  return __request__("PUT", "/system/indices/mappings/remove_mapping", request, {}, {
    "Accept": ["application/json"]
  });
}
export function removeProfileFromIndexSets(request) {
  return __request__("PUT", "/system/indices/mappings/remove_profile_from", request, {}, {
    "Accept": ["application/json"]
  });
}
export function setProfile(request) {
  return __request__("PUT", "/system/indices/mappings/set_profile", request, {}, {
    "Accept": ["application/json"]
  });
}
export function getAllFieldTypes() {
  return __request__("GET", "/system/indices/mappings/types", null, {}, {
    "Accept": ["application/json"]
  });
}
